export const Disk = Object.freeze({
	DOC: 'doc',
	DOCX: 'docx',
	PDF: 'pdf',
	XLS: 'xls',
	XLSX: 'xlsx',
	PPT: 'ppt',
	PPTX: 'pptx',
	ZIP: 'zip',
	RAR: 'rar',
	ARCHIVE: 'archive',
	PSD: 'psd',
	TXT: 'txt',
	PHP: 'php',
	BOARD: 'board',
	ODF: 'odf',
	ODT: 'odt',
	ODS: 'ods',
	ODP: 'odp',
	AUDIO: 'audio',
	IMAGE: 'image',
	VIDEO: 'video',
	COMPLEX_GRAPHIC: 'complex-graphic',
	SIGN: 'sign',
	SCRIPTS: 'scripts',
	TEXT: 'text',
	ADD: 'add',
	PHOTO: 'photo',
	EMPTY: 'empty',
	LOADING: 'loading',
	FOLDER: 'folder',
	FOLDER_GROUP: 'folder-group',
	FOLDER_SHARED: 'folder-shared',
	FOLDER_COLLAB: 'folder-collab',
	FOLDER_24: 'folder-24',
	FOLDER_PERSON: 'folder-person',
} as const);

export const DiskCompact = Object.freeze({
	DOC: 'doc-compact',
	DOCX: 'docx-compact',
	PDF: 'pdf-compact',
	XLS: 'xls-compact',
	XLSX: 'xlsx-compact',
	PPT: 'ppt-compact',
	PPTX: 'pptx-compact',
	ZIP: 'zip-compact',
	RAR: 'rar-compact',
	ARCHIVE: 'archive-compact',
	PSD: 'psd-compact',
	TXT: 'txt-compact',
	PHP: 'php-compact',
	BOARD: 'board-compact',
	ODF: 'odf-compact',
	ODT: 'odt-compact',
	ODS: 'ods-compact',
	ODP: 'odp-compact',
	AUDIO: 'audio-compact',
	IMAGE: 'image-compact',
	VIDEO: 'video-compact',
	COMPLEX_GRAPHIC: 'complex-graphic-compact',
	SIGN: 'sign-compact',
	SCRIPTS: 'scripts-compact',
	TEXT: 'text-compact',
	ADD: 'add-compact',
	PHOTO: 'photo-compact',
	EMPTY: 'empty-compact',
	LOADING: 'loading-compact',
	FOLDER: 'folder-compact',
	FOLDER_GROUP: 'folder-group-compact',
	FOLDER_SHARED: 'folder-shared-compact',
	FOLDER_COLLAB: 'folder-collab-compact',
	FOLDER_24: 'folder-24-compact',
	FOLDER_PERSON: 'folder-person-compact',
} as const);
